import React from 'react';
import { SectionHeading } from './SectionHeading';
import { TestimonialMarquee } from './TestimonialMarquee';
import { BOTTOM_TESTIMONIALS } from '../data/content';
export function BottomTestimonials() {
  return <section className="py-10 sm:py-12" style={{
    paddingTop: "6px",
    paddingBottom: "0px"
  }} data-id="element-37" data-mp="ia1cd80ny7yd">
      <div className="mx-auto max-w-content px-5" style={{
      paddingTop: "35px"
    }} data-id="element-38" data-mp="n79s71yc9zwg">
        <SectionHeading eyebrow="❤️ REAL RESULTS" title="More people who" highlight="already have it" data-id="element-39" data-mp="1ax47rra1m2ke" />

        <div className="mt-6" data-id="element-40" data-mp="1fxa079o4zt3j">
          <TestimonialMarquee testimonials={BOTTOM_TESTIMONIALS} durationSeconds={42} reverse data-id="element-41" data-mp="1fw8emb9hvo7k" />
        </div>
      </div>
    </section>;
}